import LiveBy from './API/liveby'

export default new LiveBy({
  version: 1,
  endpoint: process.env.REACT_APP_API_ENDPOINT
    ? process.env.REACT_APP_API_ENDPOINT
    : 'api.liveby.com',
  secure: true
})
